import React from "react";

import DailyGoalModal from "../DailyGoalModal";
import Icon from "../Icon";
import Panel from "../Panel";

export default function V3DailyGoalPanel({ activeMobilePanels, hoursLeft, numPointsToday, pointsPerDay, updateUrl }) {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [thisPointsPerDay, setThisPointsPerDay] = React.useState(pointsPerDay);

  let modal = null;

  return (
    <Panel attrs={{ "data-testid": "daily-goal" }} className={`${activeMobilePanels === 1 ? "tw-hidden" : ""} md:tw-block`}>
      <div className="tw-flex tw-flex-row">
        <div className="tw-font-bold tw-flex-1 tw-uppercase">Daily Goal</div>
        {thisPointsPerDay && <button className="btn btn-default btn-xs" onClick={() => setModalVisible(true)}><Icon name="cog" /></button>}
      </div>
      {thisPointsPerDay && (
        <>
          <div className="tw-my-2.5">
            <span className="joystix"><span className={`tw-text-4xl ${numPointsToday >= thisPointsPerDay ? "tw-color-success" : ""}`}>{numPointsToday}</span> / {thisPointsPerDay}</span>
          </div>
          <div className="progress" style={{ height: 10, margin: "8px 0 4px" }}>
            <div className={`progress-bar ${numPointsToday >= thisPointsPerDay ? "progress-bar-success" : "progress-bar-warning"}`} style={{ width: Math.min(100, (numPointsToday / thisPointsPerDay) * 100) + "%" }}></div>
          </div>
          <div>Points today</div>
        </>
      )}
      {!thisPointsPerDay && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8 }}>
          <span>Stay motivated!</span>
          <button className="btn btn-default joystix btn-xs" onClick={() => setModalVisible(true)}>
            Set a goal
          </button>
        </div>
      )}
      {modalVisible && (
        <DailyGoalModal
          onHidden={() => setModalVisible(false)}
          onUpdate={({ pointsPerDay }) => { setThisPointsPerDay(pointsPerDay); modal.hide(); }}
          pointsPerDay={thisPointsPerDay}
          ref={(el) => modal = el}
          targetLanguageName={""}
          updateUrl={updateUrl}
        />
      )}
    </Panel>
  );
}
